import * as React from 'react';
const ColonIrritabileIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M122.08 85.08c-.37-1.91-.16-4.35 1.44-7.3 0 0-7.51 4.05-11.21 1.16 0 0-6.7 3.47-10.98-1.16 0 0-5.27 4.03-10.4-.81 0 0-6.47 2.43-10.4-.58 0 0-.68 5.05-4.04 6.36 0 0 4.28 6.94 0 10.41 0 0 5.08 4.86 1.27 12.38 0 0 5.55 3.59 5.55 8.33s-4.05 8.33-9.71 8.33-11.09-5.21-11.09-11.11c0-4.63 3.01-9.03 3.01-9.03s-3.01-3.36-3.01-8.22 2.66-4.86 2.66-4.86-4.39-8.1 1.5-12.61c0 0-3.58-13.89 8.09-13.89 4.05 0 7.16 2.78 7.16 2.78s6.82-4.17 11.09 1.39c0 0 7.63-4.05 11.67 0 0 0 5.78-5.67 13.17-1.27 0 0 6.01-4.74 11.21 1.27 0 0 7.2-1.27 8.32 5.55.68 4.17-2.08 8.33-2.08 8.33s2.08 3.59 2.08 7.29-3.12 7.87-3.12 7.87 3.46 5.55-.23 10.76c0 0 3.35 4.4 3.35 9.03s-3.12 13.54-11.32 12.27c0 0-4.39 8.22-11.32 2.78 0 0-2.31.87-2.31 6.94"
      className="prefix__cls-2"
    />
    <path
      d="M101.33 137.49c0-4.17-5.55-4.74-5.55-11.11 0-10.34 11.09-8.33 11.09-8.33s5.43-5.55 11.09-1.39c0 0 1.3-2.28 3.31-3.47M73.62 122.22c4.17 3.12-1.39 8.1 5.55 9.72"
      className="prefix__cls-2"
    />
    <circle cx={115.67} cy={98.01} r={9.15} className="prefix__cls-1" />
    <circle cx={115.67} cy={98.01} r={1.31} className="prefix__cls-1" />
  </svg>
);
export default ColonIrritabileIcon;
